function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./ClientManager", "./reducer"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./ClientManager"), require("./reducer"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.ClientManager, global.reducer);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _ClientManager, _reducer) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports["default"] = void 0;
  Object.defineProperty(_exports, "reducer", {
    enumerable: true,
    get: function get() {
      return _reducer["default"];
    }
  });
  Object.defineProperty(_exports, "setPosition", {
    enumerable: true,
    get: function get() {
      return _reducer.setPosition;
    }
  });
  Object.defineProperty(_exports, "setScreen", {
    enumerable: true,
    get: function get() {
      return _reducer.setScreen;
    }
  });
  _ClientManager = _interopRequireDefault(_ClientManager);
  _reducer = _interopRequireWildcard(_reducer);
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  var _default = _exports["default"] = _ClientManager["default"];
});